import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import TenantPage from 'layouts/TenantPage';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import toast from 'shared/utils/toast';
import { ticketingService } from '../TicketingService';
import { useTicketColumns } from '../tickets';

export const TechnicianCreatedTickets = () => {
  const translationPrefix = 'pages.tickets';
  const { t } = useTranslation();
  const datagridRefresh = useRef(null);

  const handleDelete = (id: number) => {
    ticketingService.delete(id).then(() => {
      toast.success(t('actions.successfully.deleted'));
      datagridRefresh.current();
    });
  };

  const columns = useTicketColumns({
    handleDelete,
    excludeFields: ['warehouse_code']
  });

  return (
    <TenantPage
      title={t(`${translationPrefix}.technician-created`)}
      subtitle={t(`${translationPrefix}.technician-created-subtitle`)}>
      <EnhancedDataGrid
        columns={columns}
        service={ticketingService}
        getMethod={ticketingService.getTechnicianCreated}
        refresh={datagridRefresh}
        disableDelete
      />
    </TenantPage>
  );
};

export default TechnicianCreatedTickets;
